var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSqrlinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,0H1C0.4,0,0,0.4,0,1v16c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V1C18,0.4,17.6,0,17,0z M5.3,15.3H2.7V6.7h2.7V15.3z M4,5.6 C3.1,5.6,2.5,4.9,2.5,4c0-0.9,0.7-1.5,1.5-1.5c0,0,0,0,0,0c0.9,0,1.5,0.7,1.5,1.5C5.6,4.9,4.9,5.6,4,5.6z M15.3,15.3h-2.7v-4.2 c0-1,0-2.3-1.4-2.3c-1.4,0-1.6,1.1-1.6,2.2v4.2H7V6.7h2.6v1.2h0c0.4-0.7,1.2-1.4,2.5-1.4c2.7,0,3.2,1.8,3.2,4.1L15.3,15.3L15.3,15.3 z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqrlinkedin);
export default __webpack_public_path__ + "static/media/sqrlinkedin.0ec0d9803bef755bbca00a4c28aa0d97.svg";
export { ForwardRef as ReactComponent };